import { Link } from "react-router-dom";
import { RESOURCES } from "../../nav/navigation";

export function ResourcesMenu({ onNavigate }: { onNavigate: () => void }) {
  return (
    <div className="mm">
      <div className="mm__cols">
        {RESOURCES.map((group) => (
          <div key={group.title} className="mm__col">
            <h4>{group.title}</h4>
            <ul>
              {group.links.map((link) =>
                link.external ? (
                  <li key={link.href}>
                    <a href={link.href} onClick={onNavigate}>
                      {link.label}
                    </a>
                  </li>
                ) : (
                  <li key={link.href}>
                    <Link to={link.href} onClick={onNavigate}>
                      {link.label}
                    </Link>
                  </li>
                ),
              )}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
